import {get, post, put,Delete} from '../axios'


// 基本参数-修改
export const basicUpdate = params => put('/web/system/basic/update',params);

// 基本参数-查看
export const basicView = params => get(`/web/system/basic/view`);